<template>
  <div class="about">
    <template>
      <v-alert
        icon="mdi-information"
        close-text="Tutup"
        colored-border
        border="left"
        dismissible
        type="info"
        :class="meta.is_lengkap ? 'sc-notif' : 'bg-notif'"
        :color="meta.is_lengkap ? 'green' : 'yellow darken-2'"
      >
        <b>Hai {{ $getDeepObj(ptk, 'nama') }}!</b>
        <template v-if="meta.is_lengkap">
          Anda <strong>telah melengkapi</strong> esai yang telah kami sediakan .
        </template>
        <template v-else>
          Silakan melengkapi esai yang telah kami sediakan dibawah ini. Selesaikan paling lambat tanggal
          <b> {{ $localDate(wktTutup) }} pkl. 23.59 WIB </b>
        </template>
      </v-alert>
    </template>

    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <h1 class="headline info--text">Kelengkapan Esai</h1>
            <div class="subtitle-1 black--text">
              Anda sedang berada di seleksi tahap 1 pendaftaran Program Sekolah Penggerak
            </div>
            Anda memiliki waktu hingga
            <b> {{ $localDate(wktTutup) }} pkl. 23.59</b>
            untuk melengkapi Data Esai.<br />
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left px-0">
                      <h3 class="title orange--text">Status</h3>
                    </th>
                  </tr>
                  <tr>
                    <th class="text-left body-2 font-weight-bold px-0">
                      <v-row no-gutters class="py-1">
                        <v-col cols="12" md="8">Prasyarat Kelengkapan Data</v-col>
                        <v-col class="d-none d-sm-flex" cols="12" md="4">Status/Pemenuhan</v-col>
                      </v-row>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="px-0">
                      <v-row no-gutters class="py-1">
                        <v-col cols="10" md="8">Kelengkapan Esai</v-col>
                        <v-col cols="2" md="4">
                          <v-icon :color="meta.is_lengkap ? 'success' : 'grey'">
                            {{ meta.is_lengkap ? 'mdi-check-circle' : 'mdi-alert-circle' }}
                          </v-icon>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <div class="mt-5 grey lighten-4 black--text pa-2" style="font-size: 0.8rem; border-radius: 5px">
              <b>Keterangan Status :</b> <br />
              <i class="v-icon notranslate mdi mdi-check-circle theme--light success--text" style="font-size: 1rem" />
              &nbsp;Langkah seleksi sudah selesai<br />
              <i class="v-icon notranslate mdi mdi-help-circle theme--light warning--text" style="font-size: 1rem" />
              &nbsp;Status syarat Opsional, Apabila tidak memiliki maka tidak wajib diisi <br />
              <i
                class="v-icon notranslate mdi mdi-alert-circle theme--light grey--text grey-lighten-2"
                style="font-size: 1rem"
              />
              &nbsp; Wajib diisi dan belum dilengkapi/diselesaikan
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-alert
      icon="mdi-information"
      close-text="Tutup"
      border="left"
      type="info"
      class="bg-notif"
      colored-border
      color="primary"
    >
      <b>Petunjuk Pengisian</b>
      <ol style="list-style: lower-alpha" class="pl-0">
        <li>
          Jawablah pertanyaan-pertanyaan dengan spesifik dan detail, untuk memudahkan mendapatkan informasi yang lengkap
          mengenai pengalaman Anda.
        </li>
        <li>
          Jawablah pertanyaan-pertanyaan yang ada sesuai dengan kejadian / peristiwa yang pernah Anda lakukan / alami
          dalam pekerjaan / tugas Anda.
        </li>
        <li>
          Jawablah pertanyaan-pertanyaan dengan kejadian / peristiwa yang paling baru / terkini atau maksimal dalam
          kurun waktu 3 (tiga) tahun terakhir.
        </li>
        <li>Jawab pertanyaan dengan jujur dan berpikir positif mengenai diri Anda sendiri.</li>
        <li>
          Sebelum menekan tombol <b>SIMPAN</b> bacalah kembali jawaban Anda dengan seksama, karena jawaban Anda
          <b>TIDAK BISA DIREVISI</b> setelah menekan tombol <b>SIMPAN</b>.
        </li>
      </ol>
    </v-alert>

    <v-row>
      <v-col cols="12">
        <h1 class="headline py-2">Kelengkapan Esai</h1>
        <v-expansion-panels tile flat v-model="tab">
          <v-expansion-panel
            v-for="(exp, i) in expansion"
            :key="i"
            :disabled="(stepper && isInvalidKategori(i) && isSebagianKategori(i)) || statusLengkap[i + 1]"
          >
            <v-expansion-panel-header class="px-4 subtitle-1">
              <strong>
                {{
                  env !== 'demo'
                    ? exp.title
                    : `${i +
                        1}. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`
                }}
              </strong>
            </v-expansion-panel-header>
            <v-divider></v-divider>
            <v-expansion-panel-content v-if="!statusLengkap[i + 1]" class="px-0">
              <v-container fluid class="px-0">
                <v-alert border="left" class="bg-info" color="#bbdefb" colored-border dense>
                  <v-row no-gutters dense>
                    <v-col class="grow"> Kelengkapan data esai</v-col>
                    <v-col class="shrink">
                      <v-btn right depressed small color="info" :disabled="statusLengkap[i + 1]" @click="onEdit">
                        <v-icon small>mdi-pencil</v-icon>
                        {{ statusLengkap[i + 1] ? 'Ubah' : 'Lengkapi' }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <template v-for="item in items">
                        <view-data
                          v-if="i + 1 === item.nomor"
                          :key="item.id"
                          :ref="`tab-${item.id}`"
                          :type="(item.id || '').toString()"
                          :valid="isValidEsai[item.id]"
                          :value="getEsai(item.id)"
                          :pertanyaan="`${item.kode}. ${item.pertanyaan}`"
                          :min="Number(item.min_kata)"
                          :max="Number(item.maks_kata)"
                          @edit="onEdit"
                        ></view-data>
                      </template>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- modal form -->
    <base-modal-full
      generalError
      :autoClose="false"
      ref="modal"
      title="Formulir Esai"
      lblBtn="Kirim"
      @save="onSave"
      @close="onCloseModal"
    >
      <form-esai
        ref="formulir"
        generalError
        :title="formulir.title"
        :initValue="formulir.init"
        :items="formulir.items"
        :header="formulir.header"
        @mutate="onMutate"
      ></form-esai>
    </base-modal-full>
  </div>
</template>
<script>
import mixin from './mixin';
import FormEsai from '../formulir/Esai';
import ViewData from './View';

export default {
  name: 'Home',
  mixins: [mixin],
  components: {
    FormEsai,
    ViewData,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    expansion: {
      type: Array,
      default: () => [],
    },
    role: {
      type: String,
      default: '',
    },
    stepper: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
.bg-info {
  background-color: #e3f2fd;
}
.bg-success {
  background-color: #a5d6a7 !important;
}
</style>
